const vfilter = {
  // 格式化 文件大小
  filterType: function (val) {
    if (val === 0) return "0KB";
    var k = 1024;
    var sizes = ["B", "KB", "MB", "GB", "PB", "TB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(val) / Math.log(k));
    return (val / Math.pow(k, i)).toPrecision(3) + "" + sizes[i];
  },
  // 格式化 视频长短
  filterVideo: function (value) {
    if (!value) return "00:00:00";
    var allseconds = parseInt(value, 10);

    var hours = Math.floor(allseconds / 3600);
    var minutes = Math.floor((allseconds % 3600) / 60);
    var seconds = allseconds % 60;

    return (
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds)
    );
  },
};
export default vfilter;
